<template>
    <div class="parent">
        <banner v-bind:bannerObj="bannerObj"></banner>
        <div class="container">
            <div class="content">
                <div class="curmbsLink">
                    <router-link to="/">加入我们</router-link>
                    <span> > </span>
                    <span>职位详情</span>
                </div>
                <div class="title">资深产品经理</div>
                <div class="table-detail">
                    <div>
                        <span>工作地点</span>
                        <i>上海</i>
                        <span>招聘人数</span>
                        <i>1人</i>
                        <span>职位类别</span>
                        <i>产品/项目类</i>
                        <span>工作年限</span>
                        <i>五年以上</i>
                    </div>
                    <div>
                        <span>学历要求</span>
                        <i>本科</i>
                        <span>所属部门</span>
                        <i>国际事业部</i>
                        <span>薪酬范围</span>
                        <i>面议</i>
                        <span>发布时间</span>
                        <i>2018-03-30</i>
                    </div>
                </div>
                <div class="description">
                    <span>岗位描述：</span>
                    <p>
                        1. 主要负责跨境收单产品的设计及产品规划；<br/>
                        2. 负责业务解决方案及撰写产品需求文档；<br/>
                        3. 负责产品开发上线完整的项目管理；包括制订项目计划，跟踪推动项目进展，协调安排资源等；<br/>
                        4. 负责境外商户接入，跟踪和分析公司与跨境客户、跨境合作伙伴及跨境第三方支付的资金流转模式，确定平台的支付结算流程及具体操作细 则，并在实际运行过程中不断优化；<br/>
                        5. 跟进产品上线后的运营状况，搜集需求管理产品的迭代优化；<br/>
                        6. 支付产品同业调研及分析，现有功能与产品的优化改进，积极关注第三方支付行业动态，具备敏锐的触觉及看法。<br/>
                    </p>
                    <span>岗位要求：</span>
                    <p>
                        1. 4年以上支付公司、互联网公司产品经理的工作经验或从事金融、经济工作；<br/>
                        2. 有跨境支付或跨境电商产品相关经验者优先；<br/>
                        3. 熟悉产品生命周期全过程，能够进行产品需求分析、竞品分析，撰写需求文档，具有良好的项目管理能力；<br/>
                        4. 熟悉产品设计的各种工具和软件；<br/>
                        5. 计算机、金融、会计相关专业优先；<br/>
                        6. 能够发现并解决问题的能力，良好的语言沟通能力、团队协作能力；<br/>
                        7. 人际关系处理能力佳者优先，能很好协调跨公司、跨部门的组织协调能力；<br/>
                        8. 责任心和抗压能力强，工作有热情，具有较好的英语阅读、口语能力。<br/>
                    </p>
                    <span>工作地点：</span>
                    <p>上海</p>
                    <b> 请将简历投递至 GEPrecruit@gepholding.com</b>
                </div>
            </div>
        </div>
        <footer>
            <footContent></footContent>
        </footer>
    </div>
</template>

<style lang="scss">
    .parent{
        background-color: #fff;
        .container {
            width: 1200px;
            margin: 0 auto;
            padding-top: 64px;
        }
        .content { margin-bottom: 80px; }
        .curmbsLink {
            width: 100%;
            line-height: 30px;
            margin-bottom: 20px;
            a { color: rgba(50,50,50, 0.3); }
            a:hover { color: #323232; }
        }
        .title {
            font-size: 40px;
            margin: 30px auto;
        }
        .table-detail {
            margin-bottom: 30px;
            div:last-child { border: none; }
            div {
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                text-align: center;
                line-height: 60px;
                border-bottom: 3px solid rgba(115, 112, 133, 0.5);
                span {
                    display: block;
                    width: 100px;
                    height: 60px;
                    color: #fff;
                    background: rgba(146, 143, 167, 0.6);
                }
                i {
                    display: block;
                    flex: 1;
                    background: #fafafb;
                }
            }
        }
        .description {
            span {
                display: block;
                padding: 20px 0;
            }
            p {
                display: block;
                line-height: 30px;
                margin-bottom: 40px;
            }
            b { display: block; font-weight: 500;}
        }
    }

</style>


<script>
import store from '../vuex'
import DetailBanner from '../components/DetailBanner'
import FootContent from "../components/FootContent";
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/join.png'),
            text: 'JOIN US',
        }
      }
  },
  components:{
    'banner': DetailBanner,
    'footContent': FootContent,
  },
  store,
}
</script>

